<div class="dx-card dx-wide-card" style="padding: 10px; overflow: auto; height: 100%; margin:0; padding: 0;">
  <h2 style="padding:10px 10px 0 10px; margin:0;" [innerHtml]="TitleContent"></h2>
  <div id="ProjectionContainer" style="overflow:auto; margin:0; padding:0;" [innerHtml]="HTMLContent"></div>
  <!--<iframe [srcdoc]="HTMLValue" style="width:100%; height: 600px; border:0;"></iframe>-->
</div>
